import { Ng2StateDeclaration } from '@uirouter/angular';
import { ClusterViewComponent } from '@fi-app/cluster/cluster-view/cluster-view.component';
import { FiClusterStateResolveCluster } from './resolve/cluster';
import { FiClusterStateResolvePageTitle } from './resolve/page-title';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiClusterViewState: Ng2StateDeclaration = {
    name: FiStateNames.Cluster.View,
    url: '/:Id',
    views: {
        '@': {
            component: ClusterViewComponent,
        },
    },
    resolve: {
        cluster: FiClusterStateResolveCluster,
        pageTitle: FiClusterStateResolvePageTitle,
    },
};
